<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" :model="form" >
                <el-form-item label="关键词">
                    <el-input v-model="form.keywords" placeholder="关键词"></el-input>
                </el-form-item>
                <el-form-item label="班级">
                    <el-select v-model="form.classId" clearable  placeholder="所有班级">
                        <el-option v-for="item in classes" :label="item.name" :value="item.id" :key="item.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div>
                <el-button type="primary" @click="exportStudents()"><i class="el-icon-download"></i>导出学生</el-button>
            </div>
        </div>
        <div class="panel_body">
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                    min-width="180"
                    prop="name"
                    label="学生姓名" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="phone"
                    label="手机号" >
                </el-table-column>
                <el-table-column
                    prop="sn"
                    min-width="180"
                    label="账号" >
                </el-table-column>
                <el-table-column
                    prop="score"
                    min-width="180"
                    label="积分" >
                </el-table-column>
                <el-table-column
                    prop="parentName"
                    min-width="180"
                    label="家长姓名" >
                </el-table-column>
                <el-table-column
                    prop="school"
                    min-width="180"
                    label="学校名称" >
                </el-table-column>
                <el-table-column
                    label="操作"
                    min-width="180"
                >
                    <template slot-scope="scope">

                        <el-link type="primary" @click="edit(scope.row)"
                                 :underline="false" ><i class="iconfont icon-bianji"></i><b>编辑</b></el-link>
                        <el-popconfirm @onConfirm="del(scope.row)"
                                       title="确认删除该学生吗？"
                        >
                            <el-link type="danger" slot="reference"
                                     :underline="false" ><i class="iconfont icon-shanchu"></i><b>删除</b></el-link>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination
                :background="true"
                prev-text="上一页"
                next-text="下一页"
                layout="prev, pager, next"
                :current-page="pager.currentPage"
                :page-size="pager.pageSize"
                :total="pager.dataTotal"
                @current-change="pageChange"
            >
            </el-pagination>
        </div>

        <AddDrawer v-if="showAdd" @submit="loadData"
                   @close="showAdd=false" ></AddDrawer>

        <EditDrawer v-if="showEdit" @submit="loadData" :item="editItem"
                    @close="showEdit=false" ></EditDrawer>
    </div>
</template>

<style scoped>
    .class_title {
        display: inline-block;
        height: 40px;
        line-height: 40px;
        font-size: 16px;

    }
    .class_title i.iconfont {
        font-size: 20px;
        color: var(--primary);
    }

</style>
<style>

</style>

<script>

    import AddDrawer from './StudentAddDrawer';
    import EditDrawer from './StudentEditDrawer';


    export default {
        components: {
            AddDrawer,
            EditDrawer,
        },
        props: [
            "attr"
        ],
        data() {
            return {
                isSelf: this.attr && this.attr.isSelf == true, //是否只查询自己教任班级的

                showAdd: false,
                showEdit: false,
                editItem: {},

                classes: [],
                form: {
                    keywords: "",
                },

                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
                tableData: [ ],
            }

        },

        watch: {
            "form": {
                handler: function (newValue) {
                    this.pager.currentPage = 1;
                    this.loadData();
                },
                deep: true

            }
        },

        methods: {
            add() {
                this.showAdd = true;
            },
            edit(item) {
                this.editItem = {...item};
                this.showEdit = true;
            },
            del(item) {
                this.$ajaxGet("/user/removeStudent/" + item.id, (data) => {
                    this.loadData();
                })
            },


            loadData() {
                let url = null;
                if (this.isSelf) {
                    url = "/user/listSelfClassStudents";
                } else {
                    url = "/user/list";
                }

                this.$ajaxPost(url, {
                    form: this.form,
                    isStudent: true,
                    pager: {...this.pager, dataTotal: 0}
                }, (data) => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    let {offset, ...pager} = data.pager;
                    this.pager = pager;
                    this.tableData = data.result;
                    this.showAdd = false;
                    this.showEdit = false;
                })
            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadData();
            },
            loadClassList() {
                let url = null;
                if (this.isSelf) {
                    url = "/class/listSelf";
                } else {
                    url = "/class/list";
                }
                this.$ajaxPost(url, {
                    form: {
                        enable: true,
                        hasEnable:true
                    }
                }, data => {
                    this.classes = data.result;
                })
            },
            exportStudents() {
                if (this.isSelf ) {

                    window.open("/user/exportSelfClasStudents?token="+localStorage.getItem("token"));
                } else {

                    window.open("/user/exportStudents?token="+localStorage.getItem("token"));
                }
            }

        },

        created() {
            this.loadData();
            this.loadClassList();
        }

    }
</script>
